import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/** A spinner with its loading text, for a list panel whose first load is still running. */
export function LoadingRow({ label }: { label: string }) {
  return (
    <Stack direction="row" spacing={1.5} alignItems="center" sx={{ p: 1 }}>
      <CircularProgress size={18} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  );
}
